export default class ContractedOverrideItem {
  constructor(selectedItems) {
    this.PlanningDetailIds = selectedItems.map((item) => item.PlanningDetailId);
    this.OriginalTotal = selectedItems.reduce(
      (sum, item) => sum + (item.NumberOfContractedAssignmentsOriginal || item.NumberOfContractedAssignments || 0),
      0
    );
    this.DistributionType = 'even';
    this.NewTotal = 0;
    this.Items = selectedItems.map((item) => ({
      PlanningDetailId: item.PlanningDetailId,
      label: `${item.PlanningDetailId} - ${item.CountryName}`,
      override: 0,
    }));
  }
}
